import React from "react";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import {dialogTitleCommonStyle} from "./dialogTitleCommonStyle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

interface Props {
  title: string | any;
}

const DialogTitleCommon: React.FC<Props> = ({title}) => {
  return (
    <DialogTitle sx={dialogTitleCommonStyle.dialogTitle}>
      <Typography component="p" sx={dialogTitleCommonStyle.dialogTitleText}>
        {title}
      </Typography>
    </DialogTitle>
  );
};

export default DialogTitleCommon;

export function DialogCloseCommon({onClick}: {onClick: () => void}) {
  return (
    <IconButton
      aria-label="close"
      size="small"
      onClick={onClick}
      sx={{
        color: "#fff",
        position: "absolute",
        right: 5,
        top: 3,
      }}>
      <CloseIcon />
    </IconButton>
  );
}
